import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

/**
 * The confirm-before-acting popup both portals use — the same shape as the
 * Communication Hub's "Resend this message?" dialog: warning icon + title,
 * a message, an optional warning box, then Cancel (outlined) and the action
 * (contained, red by default, with its icon).
 *
 * Every size, weight, spacing and colour comes from the surrounding MUI theme,
 * so the partner side picks up its own brand without any hardcoded CSS.
 */
export default function ConfirmDialog({
  open,
  title,
  message,
  warning,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  confirmIcon,
  confirmColor = 'error',
  onConfirm,
  onCancel,
  loading = false,
}) {
  return (
    <Dialog open={open} onClose={() => !loading && onCancel()} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ typography: 'h5', display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon fontSize="small" color="warning" />
        {title}
      </DialogTitle>
      <DialogContent>
        {message && (
          <Typography variant="body1" color="text.secondary">
            {message}
          </Typography>
        )}
        {warning && (
          <Alert severity="warning" sx={{ mt: 1.5 }}>
            {warning}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onCancel} disabled={loading}>
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color={confirmColor}
          startIcon={confirmIcon}
          onClick={onConfirm}
          disabled={loading}
          autoFocus
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
